export const LOGOUT = 'AUTH/LOGOUT';
export const AUTH_API_REQUEST = 'AUTH/AUTH_API_REQUEST';
export const AUTH_API_SUCCESS = 'AUTH/AUTH_API_SUCCESS';
export const AUTH_API_FAILED = 'AUTH/AUTH_API_FAILED';
export const CHANGE_PASSWORD_REQUEST = 'AUTH/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'AUTH/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'AUTH/CHANGE_PASSWORDFAILED';
export const RESET_PASSWORD_REQUEST = 'AUTH/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'AUTH/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'AUTH/RESET_PASSWORDFAILED';
